import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./EmployeeLogin.css";

export default function EmployeeLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const employees = [
    {
      name: "Lloyd Business School",
      location: "Greater Noida",
      email: "Chawlamanish180@gmail.com",
      password: "lloyd@123",
      mobile: "8949820593",
      referral: "EMP1001",
      position: "Training Coordinator",
    },
    {
      name: "Arya Sagar Palkritwar",
      location: "Jagdish Seth School of Management, Bangalore",
      email: "Palkritwarya@gmail.com",
      password: "arya@123",
      mobile: "9325433301",
      referral: "EMP1002",
      position: "Placement Coordinator",
    },
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const found = employees.find(
      (emp) =>
        emp.email === formData.email.trim() &&
        emp.password === formData.password.trim()
    );

    if (found) {
      localStorage.setItem("loggedInEmployee", JSON.stringify(found));
      navigate("/EmployeeDashboard");
    } else {
      setError("Invalid email or password. Please try again.");
    }
  };

  return (
    <div className="employee-login-page">
      <div className="login-container">
        <h2>Employee Login</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>

          {error && <p className="error-msg">{error}</p>}

          <button type="submit" className="login-btn">
            Login
          </button>
        </form>

        {/* ⭐ New Employee Registration Button */}
        <button
          className="register-btn"
          onClick={() => navigate("/EmployeeRegister")}
        >
          Register as New Employee
        </button>
      </div>
    </div>
  );
}
